export default import.meta.ROLLDOWN_FILE_URL_qj1on8j9yOfH2extuZKCPg